var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.962,
    height: 23.726,
    viewBox: "0 0 24.962 23.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M-2874.045-3338.437v-9.1c0-.107,0-.108.107-.128l3.181-.6,2.76-.521,3.46-.653,2.414-.455,2.142-.4c.091-.017.091-.017.091.073v2.2c0,.1,0,.1.1.1h9.48a1.19,1.19,0,0,1,.928.387,1.134,1.134,0,0,1,.3.741c0,.023,0,.046,0,.07q0,8.289,0,16.579a1.139,1.139,0,0,1-.6,1.049,1.127,1.127,0,0,1-.577.147h-9.509c-.134,0-.118-.016-.118.118q0,1.091,0,2.182c0,.083,0,.085-.081.071l-1.434-.271-2.978-.561-2.542-.48-2.869-.541-2.93-.552c-.41-.077-.82-.155-1.231-.229-.069-.013-.092-.036-.092-.11Q-2874.044-3333.884-2874.045-3338.437Z",
    transform: "translate(2874.047 3350.306)",
    fill: "#016C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M-1848.9-3105.1a.162.162,0,0,0-.082-.007q-1.634,0-3.268,0c-.058,0-.078-.01-.077-.074,0-.214,0-.429,0-.644,0-.062.013-.08.078-.08,1.089,0,2.179,0,3.269,0,.069,0,.081-.019.081-.083q0-1,0-1.994c0-.075-.022-.087-.091-.087-1.087,0-2.175,0-3.262,0-.062,0-.076-.015-.075-.076,0-.459,0-.919,0-1.378,0-.023,0-.046,0-.069.021-.016.045-.009.067-.009h9.674c.022,0,.046-.01.065.01v0h0c.021.019.011.043.011.065q0,8.453,0,16.905c0,.022.01.046-.011.065h0v0c-.019.021-.043.01-.065.01h-9.674c-.022,0-.046.008-.067-.008q0-.468,0-.935c0-.171,0-.342,0-.512,0-.06.013-.076.075-.076q1.627,0,3.254,0c.1,0,.1,0,.1-.1,0-.66,0-1.32,0-1.98,0-.073-.022-.084-.088-.084-1.087,0-2.174,0-3.261,0-.062,0-.08-.015-.079-.078,0-.2,0-.4,0-.6,0-.056.017-.067.07-.067,1.1,0,2.2,0,3.3,0,.067,0,.083-.015.083-.083q0-.993,0-1.987c0-.064-.011-.084-.081-.084-1.1,0-2.193,0-3.289,0-.064,0-.08-.017-.078-.079q.006-.329,0-.658c0-.059.017-.071.073-.071,1.094,0,2.188,0,3.282,0,.065,0,.085-.012.084-.082,0-.669,0-1.339,0-2.008,0-.023.014-.05-.011-.07a.159.159,0,0,1-.075.006h-3.266c-.026,0-.055.01-.08-.01q0-.405,0-.81c0-.031.013-.04.041-.038s.037,0,.055,0h3.247a.175.175,0,0,0,.082-.006Q-1848.9-3104.023-1848.9-3105.1Z",
    transform: "translate(1866.481 3112.928)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M-2617.772-2805.591c.012-.045.026-.09.038-.136a7.975,7.975,0,0,1,.536-1.354c.238-.53.48-1.058.717-1.588a.111.111,0,0,1,.112-.075c.564-.037,1.127-.078,1.691-.118.021,0,.041,0,.062,0a.132.132,0,0,1-.028.071q-1.053,2.009-2.108,4.017a.142.142,0,0,0,0,.151q1.089,2.045,2.174,4.092l.038.075-.488-.032-.918-.064c-.166-.011-.331-.024-.5-.034a.083.083,0,0,1-.082-.057q-.582-1.307-1.167-2.613a2.3,2.3,0,0,1-.131-.48.149.149,0,0,0-.02-.069c-.006.008-.014.015-.015.022a4.341,4.341,0,0,1-.366,1q-.453.974-.9,1.953a.083.083,0,0,1-.1.057c-.46-.034-.92-.065-1.38-.1l-.237-.019.1-.2q.94-1.76,1.881-3.52a.108.108,0,0,0,0-.114q-.89-1.82-1.779-3.641l-.006-.012c-.033-.07-.033-.069.042-.074l1.3-.092c.1-.007.2-.01.3-.019a.075.075,0,0,1,.092.056c.233.574.469,1.147.7,1.721a7.182,7.182,0,0,1,.394,1.084c.008.036.018.071.027.106Z",
    transform: "translate(2624.35 2816.363)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M-1144.379-3091.828c0-.028,0-.056,0-.083q0-8.435,0-16.87c0-.027,0-.055,0-.083.031.022.017.055.017.083q0,1.485,0,2.971,0,6.942,0,13.884C-1144.362-3091.893-1144.346-3091.855-1144.379-3091.828Z",
    transform: "translate(1168.34 3112.208)",
    fill: "#186e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M-1842.169-3110.067l-.069,0h-9.737c.03-.027.066-.015.1-.015h9.615C-1842.229-3110.084-1842.195-3110.1-1842.169-3110.067Z",
    transform: "translate(1866.134 3113.415)",
    fill: "#126a39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M-1851.975-1879.363h9.737l.069,0c-.026.029-.06.018-.091.018h-9.615C-1851.909-1879.347-1851.945-1879.336-1851.975-1879.363Z",
    transform: "translate(1866.134 1899.742)",
    fill: "#126a39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M-1851.949-2568.228h3.359c.021,0,.041,0,.062,0q0,1.032,0,2.063c0,.055-.006.083-.073.083q-1.648,0-3.3,0a.032.032,0,0,1-.028-.012h3.28c.1,0,.1,0,.1-.106,0-.642,0-1.283,0-1.925,0-.07-.019-.09-.089-.089q-1.614,0-3.227,0C-1851.888-2568.211-1851.922-2568.2-1851.949-2568.228Z",
    transform: "translate(1866.107 2579.062)",
    fill: "#0e6736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M-1606.036-2785.084c.019.014.01.034.01.051q0,1.024,0,2.048c0,.017.009.037-.01.051l-.005-.006a.012.012,0,0,1-.01-.01v-2.119a.013.013,0,0,1,.01-.01Z",
    transform: "translate(1623.616 2792.914)",
    fill: "#166c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M-1847.479-2784.9l-.01.01h-3.392a.056.056,0,0,1,.05-.012h3.3Z",
    transform: "translate(1865.055 2792.732)",
    fill: "#0e6736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M-1846.834-2631.014l.01.01-.062,0h-3.33v-.012Z",
    transform: "translate(1864.399 2640.978)",
    fill: "#0d6735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M-1853.687-3107.255v1.477h-.007v-1.477Z",
    transform: "translate(1867.829 3110.622)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M-1853.688-1987.355v1.477h-.007v-1.477Z",
    transform: "translate(1867.83 2006.236)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M-1853.847-2626.489v-.8h.006v.8Z",
    transform: "translate(1867.979 2637.303)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M-1853.843-2409.542v-.757h.006v.756Z",
    transform: "translate(1867.976 2423.321)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M-1853.733-2841.352v.742h-.007v-.744Z",
    transform: "translate(1867.874 2848.404)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M-1853.843-2196.646v-.7h.007v.7Z",
    transform: "translate(1867.976 2213.319)",
    fill: "#136a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M-1539.146-2785.689c.633,0,1.265,0,1.9,0,.06,0,.071.017.071.073q0,1.011,0,2.022c0,.059-.017.071-.073.071q-1.887,0-3.774,0c-.068,0-.082-.018-.082-.084q0-1,0-2.008c0-.064.019-.074.077-.074C-1540.4-2785.688-1539.774-2785.689-1539.146-2785.689Z",
    transform: "translate(1559.572 2793.512)",
    fill: "#016C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M-1537.183-2996.933l-.069,0q-1.879,0-3.759,0c-.063,0-.079-.015-.079-.078q0-1.01,0-2.022c0-.043,0-.064.057-.064q1.911,0,3.822,0l.027,0a.109.109,0,0,1,.007.061q0,1.017,0,2.035A.109.109,0,0,1-1537.183-2996.933Z",
    transform: "translate(1559.556 3003.958)",
    fill: "#016C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M-1537.183-2142.977l-.069,0q-1.879,0-3.759,0c-.063,0-.079-.015-.079-.078q0-1.011,0-2.022c0-.043,0-.064.057-.064q1.911,0,3.822,0l.027,0a.109.109,0,0,1,.007.061q0,1.017,0,2.035A.108.108,0,0,1-1537.183-2142.977Z",
    transform: "translate(1559.556 2161.832)",
    fill: "#016C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M-1539.1-2354.176q.945,0,1.891,0c.051,0,.07.009.069.066q0,1.011,0,2.022c0,.051-.011.065-.063.064q-1.9,0-3.8,0c-.054,0-.063-.017-.063-.066q0-1.011,0-2.022c0-.052.012-.065.064-.065C-1540.368-2354.175-1539.733-2354.176-1539.1-2354.176Z",
    transform: "translate(1559.533 2367.977)",
    fill: "#016C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M-1540.62-2568.376c.025,0,.05,0,.076,0q1.88,0,3.759,0c.061,0,.08.012.08.077,0,.669,0,1.338,0,2.008a.129.129,0,0,1-.006.068.154.154,0,0,1-.075.006h-3.754c-.1,0-.085.01-.085-.085q0-1,0-1.995A.147.147,0,0,1-1540.62-2568.376Z",
    transform: "translate(1559.1 2579.213)",
    fill: "#1e7143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M-1541.2-2568.014q0,1.028,0,2.056c0,.091,0,.091.092.091h3.815c-.018.022-.043.01-.064.01q-1.891,0-3.781,0c-.061,0-.076-.014-.076-.075,0-.672,0-1.344,0-2.015C-1541.212-2567.968-1541.227-2568-1541.2-2568.014Z",
    transform: "translate(1559.68 2578.851)",
    fill: "#1f7244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M-1259.054-2996.659v-2.156c.035.009.019.038.019.057q0,1.021,0,2.042C-1259.035-2996.7-1259.019-2996.668-1259.054-2996.659Z",
    transform: "translate(1281.426 3003.685)",
    fill: "#0d6735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M-1259.054-2142.707v-2.156c.035.009.019.038.019.057q0,1.022,0,2.043C-1259.035-2142.744-1259.019-2142.716-1259.054-2142.707Z",
    transform: "translate(1281.426 2161.562)",
    fill: "#0d6735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M-1537.2-2567.094c.616,0,1.232,0,1.849,0,.069,0,.091.017.091.088q0,.973,0,1.945c0,.072-.022.088-.091.088q-1.852,0-3.7,0c-.065,0-.087-.016-.087-.084q0-.976,0-1.953c0-.068.022-.085.087-.084C-1538.438-2567.093-1537.819-2567.094-1537.2-2567.094Z",
    transform: "translate(1557.635 2577.945)",
    fill: "#016C37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.deb6580fcb07646478df874d69393136.svg";
export { ForwardRef as ReactComponent };